import styled from 'styled-components';

export const Flex = styled.div`
  display: flex;
  gap: 25px;
  width: 100%;
  padding: 20px 0;
  align-items: center;
`;
